import React from "react";
// @ts-ignore
import {Link} from "react-router-dom";
// @ts-ignore
import classNames from 'classnames';

import Constants from "../../../data/Constants";
import TierNavbar from "./TierNavbar";
import Colors from "../../../assets/colors/Colors";
import Images from "../../../assets/images/Images";
import styled from "styled-components";
import {useTranslation} from "react-i18next";

const TierIndexContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1% 2%;
  position: relative;

  &:after {
    content: '';
    background-attachment: fixed;
    background-image: url(${(props: { isLife: boolean }) => props.isLife ? Images.mapBackgroundLife : Images.mapBackgroundNoLife});
    background-position: center center;
    background-repeat: no-repeat;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
  }

  &:before {
    content: '';
    background-color: ${(props: { isLife: boolean }) => props.isLife ? Colors.backgroundGray : Colors.backgroundWhite};
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -2;
  }
`;

const BigYearDiv = styled.div`
  position: fixed;
  bottom: -180px;
  right: 0;

  font-size: 300px;
  font-family: AvenirNextLTPro-Regular;
  font-weight: bold;
  opacity: 0.1;
  pointer-events: none;
`;

const TierIndexComponent: React.FC<{isLife: boolean, yearCode: string}> = ({isLife, yearCode}) => {
    const handleTierUrl = (tier: string) => {
        return Constants.routes.rankingsTierGraphics.replace(':yearCode', yearCode).replace(':tierCode', tier);
    };

    const { t } = useTranslation();
    return (
        <TierIndexContainerDiv
          isLife={isLife}
        >
            <TierNavbar backRoute={Constants.routes.rankings} isLife={isLife} yearCode={yearCode}/>
            <div
                className={classNames('ranking-container', 'basic-container')}
                style={{
                  color: isLife ? Colors.fontWhite : Colors.fontGray
                }}
            >
                <div style={{display: "flex", flexDirection: "column", marginTop: '10em', marginLeft: '15em'}}>
                    <div style={{fontSize: 60, marginBottom: 50, lineHeight: 1, fontFamily: 'DMSans-Bold'}}>
                        {t('tiers.title1')}<br/>{t('tiers.title2')}
                    </div>
                    <Link
                        to={handleTierUrl('tier1')}
                        style={{fontSize: 50, marginBottom: 20, fontFamily: 'DMSans-Medium', color: isLife ? Colors.fontWhite : Colors.fontGray}}
                    >
                        Tier 1
                    </Link>
                    <Link
                        to={handleTierUrl('tier2')}
                        style={{fontSize: 50, marginBottom: 20, fontFamily: 'DMSans-Medium', color: isLife ? Colors.fontWhite : Colors.fontGray}}
                    >
                        Tier 2
                    </Link>
                    <Link
                        to={handleTierUrl('tier2')}
                        style={{fontSize: 50, fontFamily: 'DMSans-Medium', color: isLife ? Colors.fontWhite : Colors.fontGray}}
                    >
                        Tier 3
                    </Link>
                </div>
            </div>
            <BigYearDiv>{yearCode}</BigYearDiv>
        </TierIndexContainerDiv>
    )
};

export default TierIndexComponent;
